/* ============================================
   QUOTE DASHBOARD — Payment Check (chip + card)
   Asset: dashboard-payment-check.js

   CUSTOM_PAYMENTCHECK_BY_CLAUDE (ONYX e27ee0c84a87, Ryan 2026-10-11)

   Every new online order gets a payment check before any PO goes out (the supplier charges our
   card the moment a PO is sent). The worker scores Shopify's fraud facts (lib/payment-check.js)
   and puts the result on the row as `q.paymentCheck`:
     { status: held | pending | released | refunded | clear, held, signals[{code,label,detail}],
       signalCount, total, threshold, minSignals, values, riskLevel, protect{status}, decision }

   This file draws two things, and decides nothing:
     buildPaymentHoldChip(q)   the red NEEDS VERIFICATION chip under the status pill (any viewer)
     renderPaymentCheckCard(q) the card at the top of the deal: the signs, Shopify Protect, and
                               Ryan's Release / Refund buttons (admin only; the worker refuses
                               an agent and a rep anyway)

   The buttons carry `data-payhold-action`; dashboard-main.js's click handler posts
   /payment-hold (release / hold) or opens the existing Cancel & Refund dialog (refund).

   Loaded via <script defer> BEFORE dashboard-main.js, like every RQD card module.
   ============================================ */
(function () {
  window.RQD = window.RQD || {};
  var getIsAdmin = function () { return false; };

  function esc(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }
  function money(n) {
    var v = parseFloat(n);
    if (!isFinite(v)) return '';
    return '$' + v.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }
  function pc(q) {
    var c = q && q.paymentCheck;
    return (c && typeof c === 'object') ? c : null;
  }

  window.RQD.initPaymentCheck = function (deps) {
    if (deps && typeof deps.getIsAdmin === 'function') getIsAdmin = deps.getIsAdmin;
  };

  /** The chip under the status pill. Only while the order is actually held (or still being scored). */
  function buildPaymentHoldChip(q) {
    var c = pc(q);
    if (!c || !c.held) return '';
    if (c.status === 'pending') {
      return '<span class="rqd-paycheck-chip rqd-paycheck-chip--pending" title="Shopify is still scoring this order. No PO until the payment check finishes.">Payment check pending</span>';
    }
    var title = 'Payment verification hold: ' + money(c.total) + ' with ' + (c.signalCount || 0) + ' warning signs.\n'
      + (c.signals || []).map(function (s) { return '- ' + (s.label || s.code); }).join('\n')
      + '\nNo PO or web-order purchase until Ryan releases or refunds it.';
    return '<span class="rqd-paycheck-chip" title="' + esc(title) + '">&#9888; NEEDS VERIFICATION</span>';
  }

  var STATUS_TEXT = {
    held: 'Needs verification',
    pending: 'Shopify is still scoring this order',
    released: 'Released',
    refunded: 'Refunded',
    clear: 'Clear',
  };

  /** The card. Shown to an admin whenever the order has a check that is not plainly clear. */
  function renderPaymentCheckCard(q) {
    var c = pc(q);
    if (!c || !getIsAdmin()) return '';
    if (c.status === 'clear') return '';
    var ref = q.reference;
    var held = c.status === 'held' || c.status === 'pending';
    var html = '<div class="rqd-detail__card rqd-paycheck-card' + (held ? ' rqd-paycheck-card--held' : '') + '" data-card-id="payment-check">';
    html += '<div class="rqd-detail__section-title">Payment check</div>';
    html += '<div class="rqd-detail__row"><span>Status</span><span class="rqd-paycheck-status rqd-paycheck-status--' + esc(c.status) + '">'
      + esc(STATUS_TEXT[c.status] || c.status) + '</span></div>';
    html += '<div class="rqd-detail__row"><span>Order total</span><span>' + esc(money(c.total)) + '</span></div>';
    var protect = c.protect && c.protect.status ? c.protect.status.toLowerCase() : 'unknown';
    html += '<div class="rqd-detail__row"><span>Shopify Protect</span><span>' + esc(protect) + '</span></div>';
    if (c.riskLevel) html += '<div class="rqd-detail__row"><span>Shopify risk</span><span>' + esc(String(c.riskLevel).toLowerCase()) + '</span></div>';
    var signals = c.signals || [];
    if (signals.length) {
      html += '<div class="rqd-paycheck-signs-title">Warning signs (' + signals.length + ')</div><ul class="rqd-paycheck-signs">';
      signals.forEach(function (s) {
        html += '<li><strong>' + esc(s.label || s.code) + '</strong>' + (s.detail ? '<span>' + esc(s.detail) + '</span>' : '') + '</li>';
      });
      html += '</ul>';
    }
    /* CUSTOM_PAYMENTVERIFY_BY_CLAUDE (ONYX e27ee0c84a87 phase 2, Ryan 2026-10-12) - the release rule (n4), Ryan's two checks, and the
       verification email's state. The worker enforces the rule; the greyed Release only says so first. */
    var rule = c.releaseRule || null;
    if (c.needsVerification && rule) {
      html += '<div class="rqd-detail__row"><span>Release rule</span><span>' + esc(rule.text) + '</span></div>';
      html += checkRowHtml(ref, 'photo', 'Card + ID photo', c.checks && c.checks.photo, held, verifyReadText(c.verify));
      html += checkRowHtml(ref, 'call', 'Your call', c.checks && c.checks.call, held, '');
    }
    if (c.verify) html += '<div class="rqd-detail__row"><span>Verification</span><span>' + esc(verifyStatusText(c.verify)) + '</span></div>';
    if (c.decision && c.decision.action) {
      var when = c.decision.at ? String(c.decision.at).slice(0, 10) : '';
      html += '<p class="rqd-paycheck-note">' + esc((c.decision.action === 'released' ? 'Released' : 'Refunded') + (c.decision.by ? ' by ' + c.decision.by : '') + (when ? ' on ' + when : '')
        + (c.decision.note ? '. ' + c.decision.note : '.')) + '</p>';
    }
    if (held) {
      html += '<p class="rqd-paycheck-note">No PO, PO email or web-order purchase can go out while this is held. Release it once the buyer checks out, or refund the order.</p>';
      html += '<div class="rqd-paycheck-actions">'
        + '<button type="button" class="rqd-paycheck-btn rqd-paycheck-btn--release" data-payhold-action="release" data-ref="' + esc(ref) + '"'
        + (c.needsVerification && rule && !rule.met ? ' disabled title="' + esc(rule.text + ' Mark the checks first.') + '"' : '') + '>Release</button>'
        + '<button type="button" class="rqd-paycheck-btn rqd-paycheck-btn--refund" data-payhold-action="refund" data-ref="' + esc(ref) + '"'
        + ' data-order-gid="' + esc(q.id || '') + '" data-order-name="' + esc(q.orderName || ref) + '">Refund</button>'
        + '</div>';
    } else if (c.status === 'released') {
      html += '<div class="rqd-paycheck-actions"><button type="button" class="rqd-paycheck-btn" data-payhold-action="hold" data-ref="' + esc(ref) + '">Put back on hold</button></div>';
    }
    html += '</div>';
    return html;
  }

  /* CUSTOM_PAYMENTVERIFY_BY_CLAUDE (phase 2) - one check row: its state, the checker's read beside the photo, and Pass / Fail. */
  function checkRowHtml(ref, check, label, mark, editable, read) {
    var state = mark && mark.result === 'pass' ? 'Passed' : mark && mark.result === 'fail' ? 'Failed' : 'Not done';
    var cls = mark && mark.result === 'pass' ? ' rqd-paycheck-status--released' : mark && mark.result === 'fail' ? ' rqd-paycheck-status--held' : '';
    var out = '<div class="rqd-detail__row rqd-paycheck-check"><span>' + esc(label) + '</span><span><span class="' + cls.trim() + '">' + esc(state) + '</span>';
    if (editable) {
      out += ' <button type="button" class="rqd-paycheck-btn rqd-paycheck-btn--mark" data-payhold-action="check" data-check="' + check + '" data-result="pass" data-ref="' + esc(ref) + '">Pass</button>'
        + ' <button type="button" class="rqd-paycheck-btn rqd-paycheck-btn--mark" data-payhold-action="check" data-check="' + check + '" data-result="fail" data-ref="' + esc(ref) + '">Fail</button>';
    }
    out += '</span></div>';
    if (read) out += '<p class="rqd-paycheck-note">' + esc(read) + '</p>';
    return out;
  }
  function shortWhen(iso) {
    if (!iso) return '';
    var d = new Date(iso);
    if (isNaN(d.getTime())) return '';
    return d.toLocaleString('en-US', { month: 'short', day: 'numeric', hour: 'numeric', minute: '2-digit' });
  }
  function verifyStatusText(v) {
    if (!v) return '';
    if (v.status === 'scheduled') return 'Email scheduled (about 20 minutes after the hold)';
    if (v.status === 'test-staged') return 'TEST ' + (v.testNumber || '') + ' in your inbox: reply send to email the customer';
    if (v.status === 'release-held') return 'Released: goes out at 7 AM';
    if (v.status === 'sent') return 'Emailed ' + shortWhen(v.liveSentAt) + ', no reply yet' + (v.noReplyDueAt ? ' (you are emailed if none by ' + shortWhen(v.noReplyDueAt) + ')' : '');
    if (v.status === 'replied') return 'Emailed ' + shortWhen(v.liveSentAt) + ', replied ' + shortWhen(v.lastReplyAt);
    return String(v.status || '');
  }
  function verifyReadText(v) {
    var a = v && v.answers;
    if (!a || !a.verdict) return '';
    if (a.verdict === 'complete') return "Abby's read: complete, the last four digits and the names match.";
    if (a.verdict === 'mismatch') return "Abby's read: does not add up: " + (a.mismatch || []).join('; ') + '.';
    if (a.verdict === 'unread') return "Abby's read: the reply could not be read. Please look at it.";
    return "Abby's read: still missing " + (a.missing || []).join('; ') + '.';
  }

  window.RQD.buildPaymentHoldChip = buildPaymentHoldChip;
  window.RQD.renderPaymentCheckCard = renderPaymentCheckCard;
})();
/* END CUSTOM_PAYMENTCHECK_BY_CLAUDE */
